import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Form6.css";

const Form6 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    itineraryType: "",
    earlyMorning: "",
    freeTime: "",
    interest: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelect = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

const validate = () => {
  let err = {};

  if (!formData.itineraryType) {
    err.itineraryType = "Please select itinerary type";
  }

  // ✅ Early Morning Validation (Yes/No only)
  if (!formData.earlyMorning.trim()) {
    err.earlyMorning = "Please enter Yes or No";
  } else if (
    formData.earlyMorning.trim().toLowerCase() !== "yes" &&
    formData.earlyMorning.trim().toLowerCase() !== "no"
  ) {
    err.earlyMorning = "Only Yes or No allowed";
  }

  // ✅ Free Time Validation (Yes/No only)
  if (!formData.freeTime.trim()) {
    err.freeTime = "Please enter Yes or No";
  } else if (
    formData.freeTime.trim().toLowerCase() !== "yes" &&
    formData.freeTime.trim().toLowerCase() !== "no"
  ) {
    err.freeTime = "Only Yes or No allowed";
  }

  if (!formData.interest) {
    err.interest = "Please select interest";
  }

  setErrors(err);
  return Object.keys(err).length === 0;
};

    const handleSubmit = (e) => {
      e.preventDefault();

      const isValid = validate();

      if (isValid) {
        navigate("/form7");
      }
    };

  return (
    <div className="itinerary-main">
      <div className="left-section">
        <h1>Itinerary Expectations</h1>
      </div>

      <div className="right-section">
        <form onSubmit={handleSubmit} className="itinerary-form">
          <label>Itinerary</label>
          <div className="button-group">
            {["Relaxed", "Packed itinerary"].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${formData.itineraryType === item ? "active" : ""}`}
                onClick={() => handleSelect("itineraryType", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.itineraryType && (
            <p className="error">{errors.itineraryType}</p>
          )}

          <label>Early morning starts OK?</label>
          <input
            type="text"
            name="earlyMorning"
            placeholder="Yes / No"
            value={formData.earlyMorning}
            onChange={handleChange}
          />
          {errors.earlyMorning && (
            <p className="error">{errors.earlyMorning}</p>
          )}

          <label>Free leisure time required?</label>
          <input
            type="text"
            name="freeTime"
            placeholder="Yes / No"
            value={formData.freeTime}
            onChange={handleChange}
          />
          {errors.freeTime && <p className="error">{errors.freeTime}</p>}

          <label>Interest</label>
          <div className="button-group">
            {["Shopping", "Cafe", "Local Market"].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${formData.interest === item ? "active" : ""}`}
                onClick={() => handleSelect("interest", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.interest && <p className="error">{errors.interest}</p>}

          <div className="navigation-buttons">
            <button
              type="button"
              className="back-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>

            <button type="submit" className="next-btn">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form6;
